var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSssvgnav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 80,
    viewBox: "0 0 400 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M64 0H400V80H0L64 0Z",
    fill: "url(#paint0_linear_1327_7044)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M106.44 0H400V80H41L106.44 0Z",
    fill: "url(#paint1_linear_1327_7044)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1327_7044",
    x1: 0.00000521541,
    y1: 80,
    x2: 160.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C5187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1573BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1327_7044",
    x1: 400,
    y1: 0.0000291025,
    x2: 45.7435,
    y2: 97.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4992CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSssvgnav);
export default __webpack_public_path__ + "static/media/sssvg nav.326e32e7aab1533a94a99638ec767876.svg";
export { ForwardRef as ReactComponent };